import { ReportTrendAnalysisListToolbar } from './ReportTrendAnalysisListToolbar'

const ReportTrendAnalysisListHeader = () => {
  return (
    <div className='border-0'>
      <div className='card-toolbar'>
        <ReportTrendAnalysisListToolbar />
      </div>
    </div>
  )
}

export { ReportTrendAnalysisListHeader }

